/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { Role, RoleFromJSON, RoleToJSON } from './Role';
/**
 * Map principals to roles
 * @export
 * @interface RoleMapping
 */
export interface RoleMapping {
    /**
     * 
     * @type {number}
     * @memberof RoleMapping
     */
    id?: number;
    /**
     * The principal type, such as USER, APPLICATION, ROLE, or user model name in case of multiple user models
     * @type {string}
     * @memberof RoleMapping
     */
    principalType?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleMapping
     */
    principalId?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleMapping
     */
    roleId?: number;

    role?: Role;
}

/**
 * Check if a given object implements the RoleMapping interface.
 */
export function instanceOfRoleMapping(value: object): value is RoleMapping {
    return true;
}

export function RoleMappingFromJSON(json: any): RoleMapping {
    return RoleMappingFromJSONTyped(json, false);
}

export function RoleMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'principalType': json['principalType'] == null ? undefined : json['principalType'],
        'principalId': json['principalId'] == null ? undefined : json['principalId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
        'role': json['role'] == null ? undefined : RoleFromJSON(json['role']),
    };
}

export function RoleMappingToJSON(json: any): RoleMapping {
    return RoleMappingToJSONTyped(json, false);
}

export function RoleMappingToJSONTyped(value?: RoleMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'principalType': value['principalType'],
        'principalId': value['principalId'],
        'roleId': value['roleId'],
        'role': value['role'] ? RoleToJSON(value['role']) : undefined,
    };
}

